import React from 'react'; 
import Footer from '../components/footer';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Cyber from '../../assets/gaming.png';
import Card from '../../assets/web3.png';
import Card2 from '../../assets/architecture.png';

import Header from '../menu/header2';
import { Link } from "@reach/router";

const CaseStudies = () => (
  <div>
    {/* Global styles defined inline in the component */}
    <style>
      {`
        .hover-square {
          width: 100%;
          height: 20em;
          border-radius: 10px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
          overflow: hidden;
          margin: 0 auto;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .hover-square:hover {
          transform: scale(1.05);
          box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
        }
      `}
    </style>
    
    <Header />
    <section style={{ paddingTop: '10em', backgroundColor: 'black' }}>
      <Container>
        <Row>
          <Col xs={12} md={4}>
            <Link to="/tec">
              <div className="hover-square" style={{ backgroundColor: 'white' }}>
                <img
                  src={Cyber}
                  alt="DAO Social Media - Current Project in progress"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </div>
            </Link>
            <br></br>
            <p style={{  textAlign: 'center', margin: 0, fontWeight: 'bold', fontSize: '1.4em', color: 'white' }}>
              Next Gen Gaming Integrations
            </p>
          </Col>

          <Col xs={12} md={4}>
            <Link to="/experimental">
              <div
                className="hover-square"
                style={{ 
                  backgroundColor: 'grey', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center' 
                }}
                
              >
                <img
                  src={Card}
                  alt="DAO Social Media - Current Project in progress"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}>
  
                </img>
               
              </div>
             
            </Link>
            <br></br>
            <p style={{ textAlign: 'center', margin: 0, fontWeight: 'bold', fontSize: '1.4em', color: 'white' }}>
                  Experimental Case Studies/DeFi
                </p>
          </Col>

          <Col xs={12} md={4}>
            <Link to="/architecture">
              <div
                className="hover-square"
                style={{ 
                  backgroundColor: 'grey', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center' 
                }}
                
              >
                <img
                  src={Card2}
                  alt="DAO Social Media - Current Project in progress"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}>
  
                </img>
               
              </div>
             
            </Link>
            <br></br>
            <p style={{ textAlign: 'center', margin: 0, fontWeight: 'bold', fontSize: '1.4em', color: 'white' }}>
                  Architecture Visualization
                </p>
          </Col>

          <Col xs={12} md={4}>
            {/* Empty column to maintain the three-column layout on desktop */}
          </Col>
        </Row>
      </Container>
    </section>

    <Footer />
  </div>
);

export default CaseStudies;
